import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import sureSpaceLogo from '../../assets/logo.png';
import { getAuthPageCardSx, getAuthPageShellSx } from '../../styles/portalSurfaces';

const AuthPageShell = ({ title, subtitle, children, footer, maxWidth = 420 }) => {
  const theme = useTheme();

  return (
    <Box sx={getAuthPageShellSx()}>
      <Box sx={getAuthPageCardSx(theme, { maxWidth })}>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3.25 }}>
          <Box
            component="img"
            src={sureSpaceLogo}
            alt=""
            sx={{ width: 44, height: 44, objectFit: 'contain', mb: 1.75 }}
          />
          <Typography
            sx={{
              fontSize: 20,
              fontWeight: 800,
              letterSpacing: '0.04em',
              color: 'text.primary',
              lineHeight: 1,
            }}
          >
            SURE
            <Box component="span" sx={{ color: 'primary.main' }}>
              SPACE
            </Box>
          </Typography>
        </Box>

        <Typography
          align="center"
          sx={{
            color: 'text.primary',
            fontWeight: 700,
            fontSize: { xs: '1.25rem', sm: '1.375rem' },
            letterSpacing: '-0.02em',
            lineHeight: 1.25,
            mb: subtitle ? 1 : 2.5,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body2"
            align="center"
            color="text.secondary"
            sx={{ mb: 3, lineHeight: 1.55, maxWidth: 340, mx: 'auto' }}
          >
            {subtitle}
          </Typography>
        ) : null}
        {children}
        {footer ? (
          <Box
            sx={{
              mt: 3,
              pt: 2.5,
              borderTop: '1px solid',
              borderColor: 'divider',
            }}
          >
            {footer}
          </Box>
        ) : null}
      </Box>
    </Box>
  );
};

export default AuthPageShell;
